import { Component, Inject, Prop } from 'vue-property-decorator';
import ApeironComponent from '../commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { PerfilApi } from '@conacyt/perfil-usuario-client';
import SolicitudService from '@/entities/solicitud/solicitud.service';

@Component
export default class VariablesSociodemograficasComponent extends ApeironComponent {
  @Inject('perfilApi') public readonly perfilApi: () => PerfilApi;
  @Inject('solicitudService') public readonly solicitudService: () => SolicitudService;

  @Prop({ required: false })
  public solucion: Solucion;

  @Prop({ required: false })
  public solicitud: Solicitud;

  hasVariablesSociodemograficas = false;
  public isFetching = false;
  form = this.variablesSociodemograficas;

  /**
   * Se inicializa model de form
   */
  private get variablesSociodemograficas() {
    return {
      solicitud: {
        variablesSociodemograficas: {
          disDif: {
            valor: {
              nombre: '',
            },
          },
          disCam: {
            valor: {
              nombre: '',
            },
          },
          disVer: {
            valor: {
              nombre: '',
            },
          },
          disMov: {
            valor: {
              nombre: '',
            },
          },
          disApr: {
            valor: {
              nombre: '',
            },
          },
          disOir: {
            valor: {
              nombre: '',
            },
          },
          disHab: {
            valor: {
              nombre: '',
            },
          },
          disBan: {
            valor: {
              nombre: '',
            },
          },
          disRea: {
            valor: {
              nombre: '',
            },
          },
          perteCost: {
            valor: {
              nombre: '',
            },
          },
          pertePue: {
            nombre: '',
          },
          autodenominacion: {
            nombre: '',
          },
          perteUste: {
            valor: {
              nombre: '',
            },
          },
        },
      },
      tags: [],
    };
  }
  get showNoBecaMessage() {
    return !this.isFetching && !this.hasVariablesSociodemograficas;
  }

  created() {
    if (this.form.tags) {
      this.form.tags = this.solucion.tags;
    }
    this.getSolicitudVigente();
  }

  /**
   * Obtiene los datos de la solicitud de las variables sociodemográficas
   */

  getSolicitudVigente() {
    this.isFetching = true;
    this.solicitudService()
      .find(this.solicitud.id)
      .then(
        res => {
          this.form.solicitud = { ...res, ...JSON.parse(JSON.stringify(res)) };
          this.isFetching = false;
        },
        err => {
          this.isFetching = false;
        }
      );
  }

  public isSaving(): boolean {
    return (
      this.solicitud.estado === EstadoSolicitud.EN_CAPTURA &&
      this.grantService().isSolicitante(this.solicitud, this.grantService().getUsername(), this.grantService().getUsercvu)
    );
  }
}
